import * as actionTypes from "../actionTypes";
const initialValues = {
  newEmployeeInfo: null,
};

export const managementReducer = (state = initialValues, action) => {
  switch (action.type) {
    case actionTypes.managementActionTypes.newEmployeeInfo:
      return {
        ...state,
        newEmployeeInfo: action.payload,
      };
    default:
      return state;
  }
};
